export default __webpack_public_path__ + "static/hero-bg1-mobile-33af293f312d49a93aad0401b07a496d.jpg";